<template>
	<div id="app" ref="app">
		<component :is="layout">
			<router-view />
		</component>

		<UiNotify/>
	</div>
</template>

<script>
import { syncUser } from '@services/user';
import store from './store';
import KC from '@/keycloak';
import {saveTokenToIndexedDB} from "@utils/indexedDB";
import {getEnv, VUE_APP_SERVICE_NAME} from "@services/env";
import { computed } from '@vue/composition-api';
import {mapGetters} from "vuex";

async function setTokenHandler(userToken) {
	await saveTokenToIndexedDB(userToken)
}

async function kcTokenHandler() {
	const token = KC.instance()._keycloak.token;
	const exp = KC.instance()._keycloak.tokenParsed?.exp;
	await setTokenHandler({token, exp});
}
function clearTokenHandler() {
	setTokenHandler(null);
}

export default {
	name: "App",

	provide() {
		return {
			mediaForDesktop: computed(() => this.mediaForDesk),
			mediaForSmallDesktop: computed(() => this.mediaForSmallDesk),
			mediaForMobile: computed(() => this.mediaForMobile)
		}
	},

	data() {
		return {
			map: new Map(),
			mediaForDesk: true,
			mediaForSmallDesk: false,
			mediaForMobile: false,
			isClient: true,
		}
	},

	computed: {
		...mapGetters({
			seoPageDictionary: 'dictionary/seoPage',
		}),
		metaTitle() {
			if (this.seoPage?.title) {
				return this.seoPage.title;
			}
			const appServiceName = getEnv(VUE_APP_SERVICE_NAME);
			if (!this.$route.meta?.title) {
				return appServiceName;
			}
			if (!this.$route.meta?.notAppPrefTitle) {
				return appServiceName + ' - ' + this.$route.meta.title;
			}
			return this.$route.meta.title;
		},
		metaDescription() {
			if (this.seoPage?.description) {
				return this.seoPage.description;
			}
			if (!this.$route.meta?.description) {
				return null;
			}
			return this.$route.meta.description;
		},
		seoPage() {
			if (this.seoPageDictionary) {
				return this.seoPageDictionary.find(seoPage => seoPage.ident === this.$route.name);
			}

			const title = document.querySelector("title")?.innerText;
			const description = document.querySelector("meta[name='description']")?.getAttribute("content");

			return { title, description };
		},
		layoutName() {
			return this.$route.meta.layout || 'DefaultLayout';
		},
		kcRole() {
			return this.$kc.kcRole();
		},
		layout() {
			return this.map.get(this.layoutName);
		}
	},

	watch: {
		layoutName: {
			handler(newValue) {
				if (!this.map.has(newValue)) {
					/** рефрешим layout только если он меняется */
					this.map.set(newValue, () => import(`@/layouts/${this.kcRole}/${newValue}.vue`));
				}
			},
			immediate: true
		},
		metaTitle: {
			handler(newValue) {
				console.log('metaTitle', newValue)
			},
			immediate: true
		},
		metaDescription: {
			handler(newValue) {
				console.log('metaDescription',newValue)
			},
			immediate: true
		},
	},

	created() {
		// загрузить справочники
		store.dispatch("platformBlocked/initPlatformBlockedConfig");
		store.dispatch("dictionary/__initDictionaries");
		window.addEventListener('resize', this.displayForDesktop);
		this.displayForDesktop();
	},

	mounted() {
		this.isClient = true;
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.displayForDesktop);
	},

	metaInfo() {
		const meta = [];

		if (this.metaDescription) {
			meta.push({
				name: 'description',
				content: this.metaDescription,
			});
		}

		return {
			title: this.metaTitle,
			meta
		};
	},

	methods: {
		async onAuthSuccess() {
			// console.log("onAuthSuccess")
			// отправить токен в ServiceWorker
			await kcTokenHandler();

			// синхронизировать пользователя
			syncUser()
				.catch((err) => {
					console.error(err);
				});

			// запросить участников и установить чарактер (Инвестор/ЛПИ)
			await store.dispatch("userParticipant/loadEntitiesList");
		},

		async onTokenChange() {
			// console.log("onTokenChange")
			// отправить токен в ServiceWorker
			await kcTokenHandler();
		},

		onAuthLogout() {
			// console.log("onAuthLogout")
			// отправить токен в ServiceWorker
			clearTokenHandler();
		},

		displayForDesktop() {
			this.mediaForDesk = window.innerWidth > 1024;
			this.mediaForSmallDesk = window.innerWidth > 1024 && window.innerWidth < 1500;
			this.mediaForMobile = window.innerWidth < 600;
		},
	}
};
</script>
<style>
  [v-cloak] {
    display: none;
  }
</style>